import { HStack, VStack } from "@gluestack-ui/themed";
import { Button } from "@repo/core/components/core/Button";
import { Text } from "@repo/core/components/core/Text";
import { ProposalFinancialServicesSectionProps } from "./types";
import { useDimensions } from "@repo/core/hooks/useDimensions";
import { MustShow } from "@repo/core/components/core/MustShow";

export const ProposalFinancialServicesSection = ({
  name,
  value,
  onPressChangeFinancialServices,
  isShowEditButton
}: ProposalFinancialServicesSectionProps) => {
  const { isMobile } = useDimensions();
  return (
    <VStack gap="$2">
      <Text fontSize="$xs" fontWeight={500} color="$textLight700">
        Serviços Financeiros
      </Text>
      <VStack
        p="$2"
        borderWidth={1}
        borderRadius="$lg"
        bg="$backgroundLight50"
        borderColor="$borderLight100"
      >
        <HStack gap="$3">
          <VStack justifyContent="center" flex={1} gap="$1">
            <Text fontSize="$sm" fontWeight={600} color="$textLight900">
              {name}
            </Text>
            <Text fontSize="$sm" fontWeight={500} color="$textLight800">
              {value}
            </Text>
          </VStack>

          <MustShow isVisible={!isMobile && isShowEditButton}>
            <Button
              variant="outline"
              action="secondary"
              size="md"
              text="Alterar"
              leftIcon={{
                name: "pen-square",
                color: "$secondary900",
                size: 20
              }}
              onPress={onPressChangeFinancialServices}
            />
          </MustShow>
        </HStack>
      </VStack>
      {isMobile && isShowEditButton && (
        <Button
          variant="outline"
          action="secondary"
          size="md"
          text="Alterar Serviços"
          leftIcon={{
            name: "pen-square",
            color: "$secondary900",
            size: 20
          }}
          onPress={onPressChangeFinancialServices}
        />
      )}
    </VStack>
  );
};
